<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card>
          <v-card-title>Login</v-card-title>
          <v-card-text>
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div>
              <v-text-field
                v-model="form.email"
                label="E-mail"
                required
              ></v-text-field>
              <v-text-field
                v-model="form.password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Normal with hint text"
                hint="At least 8 characters"
                counter
                @click:append="show1 = !show1"
              ></v-text-field>
              <v-btn type="submit" @click="submit" class="btn btn-primary">Login</v-btn>
            </div>
          </v-card-text>
        </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      show1: false,
      valid: false,
      form: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  methods: {
    submit() {
      //console.log("submit:", this.form.email, this.form.password);
      var self = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(self.form.email, self.form.password)
        .then(() => {
          //console.log("Post sign in: ", data);
          this.$router.replace({ name: "Travel" });
        })
        .catch(err => {
          //console.log("error", err.message);
          this.error = err.message;
        });
    }
  }
};
</script>